import {ApiResponse, detailObject} from "../interfaces";
class ActionShowDetailModal {
    private readonly actionFunction: (detail: detailObject) => void;
    private object: ApiResponse;
    constructor(func: () => void) {
        this.actionFunction = func;
    }

    /**
     * Определяет по объекту случай когда выполнится execute (Если условие проходит, то выполняется)
     * @param object
     */
    public shouldExecute(object: ApiResponse) {
        this.object = object;

        //Условие выполнится только если надо поставить фокус, но при этом не надо обновлять форму
        return object.detail && object.detail.message;
    }

    /**
     * Выполняет действие. Внутри вызывает функцию которая выполняет нужное действие
     */
    public execute() {
        const { detail } = this.object;
        this.actionFunction(detail);
    }
}
export default ActionShowDetailModal;